import {Navigate, useLocation} from "react-router";
import {useAuth} from "context/AuthContext";
import {getDefaultLandingPath, isPathAccessibleToUser} from "src/getNavigation";

/**
 * Index route inside DashboardWrapper.
 * Preserves current URL if accessible to user, otherwise redirects to default landing page.
 */
const RedirectToDefault = () => {
  const {user} = useAuth();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Extract the path segment from the current location (remove leading slash)
  const currentPath = location.pathname.slice(1);

  // If user is on a valid path, don't redirect
  if (currentPath && isPathAccessibleToUser(user, currentPath)) {
    return null; // Stay on current page
  }

  // Otherwise, redirect to default landing page
  const path = getDefaultLandingPath(user);

  if (!path) {
    return <Navigate to="/forbidden" replace />;
  }

  return <Navigate to={`/${path}`} replace />;
};

export default RedirectToDefault;
